import { render } from "./WhatsAppModalSidebarRightMessageInput.vue?vue&type=template&id=3819801c&scoped=true"
import script from "./WhatsAppModalSidebarRightMessageInput.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightMessageInput.vue?vue&type=script&lang=js"

import "./WhatsAppModalSidebarRightMessageInput.vue?vue&type=style&index=0&id=3819801c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3819801c"]])

export default __exports__